// extracted by mini-css-extract-plugin
module.exports = {"location-snippet":"location-snippet_location-snippet__eN233","location-snippet__dot":"location-snippet_location-snippet__dot__UVBrP"};